import React, { useContext, useEffect, useState } from "react";
import Modal from "react-bootstrap/Modal";
import FloatingLabel from "react-bootstrap/FloatingLabel";

import Form from "react-bootstrap/Form";

import Utils from "../../../Utils";
import ContextComponent from "../../../AppContext";
import FolderTree from "../sites/FolderTree";

const AddUserPage = ({ props }) => {
  let { setAlert, setLoadingState, setCanRedirectToLogin } = useContext(ContextComponent);
  let tableData = props?.tableData || [];
  let setTableData = props?.setTableData || (() => { });
  let [firstName, setFirstName] = useState("");
  let [lastName, setLastName] = useState("");
  let [email, setEmail] = useState("");
  let [password, setPassword] = useState("");
  let [roles, setRoles] = useState([]);
  let [sites, setSites] = useState([]);
  let [picture, setPicture] = useState("");
  let [selectedFolderId, setSelectedFolderId] = useState([]);
  let [expandedFolders, setExpandedFolders] = useState([]);

  const hideModal = (e) => {
    props.setAddModalCanOpen(false);
  };

  const saveUser = (e) => {
    setLoadingState({
      applyMask: true,
      text: "Creating user",
    });
    const success = (res) => {
      hideModal();
      setLoadingState({
        applyMask: false
      });
      setAlert({
        show: true,
        message: res?.data?.message
          ? res.data.message
          : "User added successfully!",
        type: "success",
      });
      props.loadAllUsers();
    };
    const fail = (err) => {
      setLoadingState({
        applyMask: false
      });
      if (err?.redirect) {
        setCanRedirectToLogin(true);
      }
      setAlert({
        show: true,
        message: err?.data?.message
          ? err.data.message
          : "User addition failed",
        type: "danger",
      });
      console.log(err);
    };

    let formData = {
      firstName,
      lastName,
      email,
      password,
      picture,
      sites,
      roles,
      projects: selectedFolderId
    };
    try {
      // debugger;
      // console.log(formData);
      Utils.addUser(formData).then(success, fail);
    } catch (e) {
      console.log(e);
    }
  };

  const toggleFolder = (folderId) => {
    setExpandedFolders(prev => {
      if (prev.includes(folderId)) {
        return prev.filter(id => id !== folderId);
      }
      return [...prev, folderId];
    });
  };

  const firstNameHandler = (e) => {
    let value = e?.currentTarget?.value || "";
    setFirstName(value);
  };

  const lastNameHandler = (e) => {
    let value = e?.currentTarget?.value || "";
    setLastName(value);
  };

  const emailHandler = (e) => {
    let value = e?.currentTarget?.value || "";
    setEmail(value);
  };

  const passwordHandler = (e) => {
    let value = e?.currentTarget?.value || "";
    setPassword(value);
  };

  const roleHandler = (e) => {
    let value = [].slice.call(e.target.selectedOptions).map(item => item.value) || [];
    setRoles(value);
  };

  const siteHandler = (e) => {
    // Extracting the name and checked properties from the event target
    const { name, checked } = e.target;

    // If the checkbox is checked, add its name to the selectedItems array
    // If it's unchecked, remove its name from the selectedItems array
    if (checked) {
      setSites([...sites, name]);
    } else {
      setSites(sites.filter(item => item !== name));
    }
  };

  useEffect(() => {  }, [props.addModalCanOpen]);

  const handleClose = (e) => {
    props.setAddModalCanOpen(false);
  };

  let [sitesDataAvailable, setSitesDataAvailable] = useState(false);
  let [siteData, setSiteData] = useState([]);
  const sitesFetchSuccess = (res) => {
    setLoadingState({
      applyMask: false,
    });
    //console.log(res);
    setSiteData(res.data);
    setSitesDataAvailable(true);
  };
  const sitesFetchFail = (err) => {
    setLoadingState({
      applyMask: false,
    });
    err?.message?.length && console.log(err);
    // setErrorMessage(error);
    if (err?.redirect) {
      setCanRedirectToLogin(true);
    }
  };

  useEffect(() => {
    setLoadingState({
      applyMask: true,
    });
    Utils.getAllSites().then(sitesFetchSuccess, sitesFetchFail);
  }, []);

  return (
    <>
      {
        <Modal centered show={props.addModalCanOpen} onHide={handleClose}>
          <Modal.Header closeButton>
            <Modal.Title>Add new user</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <form onSubmit={(e) => e.preventDefault()}>
              <div className="indi-add-form-wrapper d-flex flex-column">
                <div className="indi-add-form-item d-flex flex-column">
                  <div className="indi-add-form-item-input row">
                    <FloatingLabel label="First name">
                      <Form.Control
                        type="text"
                        className="indi-input-field"
                        id="firstName"
                        placeholder="Enter first name"
                        autoComplete="off"
                        onChange={firstNameHandler}
                      />
                    </FloatingLabel>
                  </div>
                </div>

                <div className="indi-add-form-item d-flex flex-column">
                  <div className="indi-add-form-item-input row">
                    <FloatingLabel label="Last name">
                      <Form.Control
                        type="text"
                        className="indi-input-field"
                        id="lastName"
                        placeholder="Enter last name"
                        autoComplete="off"
                        onChange={lastNameHandler}
                      />
                    </FloatingLabel>
                  </div>
                </div>

                <div className="indi-add-form-item d-flex flex-column">
                  <div className="indi-add-form-item-input row">
                    <FloatingLabel label="E-mail">
                      <Form.Control
                        type="text"
                        className="indi-input-field"
                        id="email"
                        placeholder="Enter email"
                        autoComplete="off"
                        onChange={emailHandler}
                      />
                    </FloatingLabel>
                  </div>
                </div>

                <div className="indi-add-form-item d-flex flex-column">
                  <div className="indi-add-form-item-input row">
                    <FloatingLabel label="Initial password">
                      <Form.Control
                        type="password"
                        className="indi-input-field"
                        id="password"
                        placeholder="Enter initial password"
                        autoComplete="off"
                        onChange={passwordHandler}
                      />
                    </FloatingLabel>
                  </div>
                </div>

                <div className="indi-add-form-item d-flex flex-column">
                  <div className="indi-add-form-item-input row">
                    {Utils.ROLES && (
                      <FloatingLabel label="Role">
                        <Form.Select
                          defaultValue={[]}
                          multiple
                          id="role"
                          size="sm"
                          className="indi-input-field indi-input-select-field indi-multi-input-select-field"
                          onChange={roleHandler}
                        >
                          {Utils.ROLES?.map((role, index) => (
                            <option value={role.value} key={index}>
                              {role.name}
                            </option>
                          ))}
                        </Form.Select>
                      </FloatingLabel>
                    )}
                  </div>
                </div>

                {/* <div className="indi-add-form-item d-flex flex-column">
                  <div className="indi-add-form-item-input row">
                    {sitesDataAvailable && (
                      <div className="d-flex indi-input-field indi-multi-input-cb-field">
                        <div className="">Sites:</div>
                        <div className="">
                          {siteData.map((item, index) => (
                            <Form.Check
                              key={`checkbox-${index}`}
                              inline
                              label={item.name}
                              name={item.name}
                              type="checkbox"
                              id={`checkbox-${index}`}
                              onChange={siteHandler}
                              defaultChecked={sites.includes(item.name)}
                            />
                          ))}
                        </div>
                      </div>
                    )}
                  </div>
                </div> */}

                <div className="indi-add-form-item d-flex flex-column mt-3">
                  <div className="indi-add-form-item-input row">
                    <div className="d-flex flex-column w-100">
                      <label className="mb-2 fw-bold">Select Folder:</label>
                        <FolderTree
                        selectionMode="multiple"
                        selectedFolderId={selectedFolderId}
                        setSelectedFolderId={setSelectedFolderId}
                        currentFolderId={null} 
                        expandedFolders={expandedFolders}
                        toggleFolder={toggleFolder}
                        />
                    </div>
                  </div>
                </div>

              </div>

              <div className="indi-add-footer">
                <div className="indi-add-page-footer-btn-wrapper float-right">
                  <button
                    type="button"
                    className="btn btn-primary"
                    onClick={hideModal}
                  >
                    Cancel
                  </button>
                  <button
                    type="button"
                    className="btn btn-primary"
                    onClick={saveUser}
                  >
                    Save
                  </button>
                </div>
              </div>
            </form>
          </Modal.Body>
        </Modal>
      }
    </>
  );
};

export default AddUserPage;
